module.exports = "https://static.cdns.space/tarot-temp/img/justice.548dbc87.webp";